import React from "react";
// import logo from "../../Assets/img/150x30.png";
import logo from "../../Assets/img/mirchi_puzzled.png";

function Logo() {
    return (
      <div className="Logo">
        <img src={logo} alt="Mirchi Puzzled" style={{height: 60}} />
      </div>
    );
  }
  
  export default Logo;